import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { fmtDateTime } from "@/lib/date";

const LABEL = {
  approve_registration: "approved", reject_registration: "declined", add_partner: "added", archive_user: "archived",
  reactivate_user: "restored", promote_to_leader: "promoted to Leader", reassign_upline: "moved people under", org_edit_user: "edited",
};
const FIELD = { name: "name", email: "sign-in email", upline_team: "team", nearest_upline_leader_id: "upline" };

export default function OrgAudit({ tick }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/org/audit").then((r) => setRows(r.data)).catch(() => {}); }, [tick]);
  return (
    <Card className="p-4 sm:p-5" data-testid="org-audit">
      <h2 className="font-serif text-xl text-[#0A1F44] mb-3">Recent changes</h2>
      {!rows.length && <p className="text-sm text-slate-500">No changes recorded yet.</p>}
      <ul className="divide-y divide-slate-100 max-h-96 overflow-auto">
        {rows.map((a) => (
          <li key={a.id} className="py-2 text-sm text-slate-700 break-words" data-testid={`org-audit-${a.id}`}>
            <b>{a.actor_name}</b> {LABEL[a.action] || a.action} <b>{a.target_name || a.new_leader_name}</b>
            {a.moves?.length ? ` (${a.moves.map((m) => m.name).join(", ")})` : ""}
            {a.changes && <span className="text-xs text-slate-600"> — {Object.keys(a.changes).filter((k) => FIELD[k]).map((k) => FIELD[k]).join(", ")}</span>}
            <span className="text-xs text-slate-500"> · {fmtDateTime(a.at)}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
